import ChoiceAndResult from './choiceandresult';
import ChoiceLabel from './choicelabel';

export {
	ChoiceAndResult,
	ChoiceLabel,
};



// WEBPACK FOOTER //
// ./src/ui/interaction/children/resultsvisualization/childcomponents/index.js